import * as React from 'react';
import styled from 'styled-components';
import { P16, P14 } from '../../../atoms';

export const StyledLabel = ({
  children,
  fontWeight = undefined,
  className = undefined,
}: {
  children: React.ReactNode;
  fontWeight?: number;
  className?: string;
}) => {
  return (
    <P16 className={className} $fontWeight={fontWeight}>
      {children}
    </P16>
  );
};

export const StyledTitle = ({ children, className }: Omit<React.ComponentProps<typeof StyledLabel>, 'fontWeight'>) => {
  return (
    <StyledLabel className={className} fontWeight={800}>
      {children}
    </StyledLabel>
  );
};

export const SDescription = styled(P14)`
  color: ${(props) => props.theme?.colors.grey2};
`;

export const StyledDescription = ({
  children,
  className,
}: Omit<React.ComponentProps<typeof StyledLabel>, 'fontWeight'>) => {
  return <SDescription className={className}>{children}</SDescription>;
};

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;
